import * as React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path stroke="#B5BFD2" strokeLinecap="round" strokeWidth="2" d="M12 7v10M7 12h10" />
  </svg>
);
